<!-- リンク集 -->
<template>
  <div class="column">
    <!-- チケットの特徴ページ -->
    <MbTicketUrl
      v-if="masterBook.content && masterBook.content.ticket_site_url"
      :url="masterBook.content.ticket_site_url"
    />
    <!-- チケットの特徴ページ -->

    <!-- 外部リンクに関する情報を持っていたらリンクを表示 -->
    <!-- description_jsonが存在しない場合があるので、masterBook.content.description_jsonを確認しているが、必須項目になるのが確認できたら不要 -->
    <MbExternalTitle
      v-if="
        masterBook.content &&
        masterBook.content.description_json &&
        masterBook.content.description_json.MbExternalTitle
      "
      :titles="masterBook.content.description_json.MbExternalTitle"
      :urls="masterBook.content.description_json.MbExternalUrl"
    />
  </div>
</template>

<script>
import { computed } from "vue";
import { useStore } from "vuex";

export default {
  name: "TheMbLinkCollection",
  setup() {
    const store = useStore();
    const masterBook = computed(() => store.getters["ticketing/masterBook"]);

    return {
      masterBook,
    };
  },
};
</script>

<style lang="scss" scoped>
.column {
  margin-top: 15px;
  align-items: stretch;
}
</style>
